class ProductAccordions extends HTMLElement {
  constructor () {
    super()

    this.itemEls = this.querySelectorAll('[data-el="product-accordions.item"]')

    this.initialiseAccordions()
  }

  initialiseAccordions () {
    this.itemEls.forEach(itemEl => {
      const triggerEls = itemEl.querySelectorAll(
        '[data-el="product-accordions.trigger"]',
      )

      this.handleClick = this.handleClick.bind(this)

      triggerEls.forEach(triggerEl =>
        triggerEl.addEventListener('click', this.handleClick),
      )
    })
  }

  handleClick (event) {
    const accordionItem = event.target.closest(
      '[data-el="product-accordions.item"]',
    )

    const currentState = accordionItem.getAttribute('aria-expanded') === 'true'

    accordionItem.setAttribute('aria-expanded', !currentState)

    accordionItem.classList.remove('prd-Accordion_Item-partial')
  }
}

customElements.define('product-accordions', ProductAccordions)
